// ----------------------------------------------------------------------
import { FONTSTYPO, SPACING } from "../palette";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, import/no-default-export
export default function Tabs(theme) {
    return {
        "MuiTab": {
            "styleOverrides": {
                "root": {
                    "&.Mui-selected": {
                        "background": theme.palette.common.white,
                    },
                    "&:hover": {
                        "background": theme.palette.common.white,
                        "color": theme.palette.primary.dark
                    },
                    "borderBottom": "0px",
                    "color": theme.palette.primary.dark,
                    "cursor": "pointer",
                    "flex": "0 1 auto",
                    "fontSize": FONTSTYPO.step0,
                    "fontWeight": 650,
                    "padding": `${SPACING.spaces}  ${SPACING.spacesL}`,
                    "textAlign": "center"
                }
            },
        },
        "MuiTabs": {
            "styleOverrides": {
                "root": {
                    ".MuiTabs-indicator": {
                        "background": theme.palette.primary.dark,
                        "height": SPACING.space3xs,
                        "top": 0
                    },
                    "justifyContent": "center"
                }
            },
        }
    };
}
